import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStore = defineStore('config', () => {
    // 主题
    const theme = ref('light')  // light 白  dark 黑
    const setTheme = (v) => {
        theme.value = v
    }

    //   侧边栏
    const sidebarCollapsed = ref(false)
    const toggleSidebar = () => {
        sidebarCollapsed.value = !sidebarCollapsed.value
    }

    //   全局loading
    const loading = ref(false)
    const setLoading = (v) => {
        loading.value = v
    }

    // chatUuid
    const chatUuid = ref(null)
    const setChatUuid = (v) => {
        chatUuid.value = v
    }

    // question
    const question = ref(null)
    const setQuestion = (v) => {
        question.value = v
    }

    // loginUserInfo
    const userLoginInfo = ref(null)
    const setUserLoginInfo = (v) => {
        userLoginInfo.value = v
    }

    // openLogin
    const openLogin = ref(null)
    const setOpenLogin = (v) => {
        openLogin.value = v
    }

    // userInfo
    const userInfo = ref(null)
    const setUserInfo = (v) => {
        userInfo.value = v
    }

    // 历史对话的侧边栏显隐
    const historySide = ref(true)
    const setHistorySide = (v) => {
        historySide.value = v
    }

    // 查询参数
    const queryData = ref(null)
    const setQueryData = (v) => {
        queryData.value = v
    }

    // 一键申请，多个学校的信息
    const multipleApply = ref(null)
    const setMultipleApply = (v) => {
        multipleApply.value = v
    }
    return {
        theme,
        setTheme,
        sidebarCollapsed,
        toggleSidebar,
        loading,
        setLoading,
        userLoginInfo,
        setUserLoginInfo,
        userInfo,
        setUserInfo,
        question,
        setQuestion,
        historySide,
        setHistorySide,
        queryData,
        setQueryData,
        openLogin,
        setOpenLogin,
        chatUuid,
        setChatUuid,
        multipleApply,
        setMultipleApply,
    }
})